import { useEffect, useState } from 'react';
import {
  Box,
  Chip,
  TextField,
  Autocomplete,
  Paper,
  useTheme,
} from '@mui/material';
import toastError from '../../toasts/toastError';
import api from '../../services/api';
import { i18n } from '../../translate/i18n';

export function WhatsappsFilter({ onFiltered, initialWhatsapps }) {
  const theme = useTheme();
  const [whatsapps, setWhatsapps] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await api.get(`/whatsapp`);
        const whatsappList = data.map((w) => ({
          id: w.id,
          name: w.name,
          channel: w.channel,
        }));
        setWhatsapps(whatsappList);
      } catch (err) {
        toastError(err);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    const select = async () => {
      if (
        Array.isArray(initialWhatsapps) &&
        Array.isArray(whatsapps) &&
        whatsapps.length > 0
      ) {
        setSelecteds(initialWhatsapps);
      }
    };
    select();
  }, [initialWhatsapps, whatsapps]);

  const onChange = (event, value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box style={{ padding: '2.5px 10px' }}>
      <Autocomplete
        multiple
        size='small'
        options={whatsapps}
        value={selecteds}
        onChange={onChange}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            const { key, ...tagProps } = getTagProps({ index });
            return (
              <Chip
                key={key}
                variant='outlined'
                sx={{
                  backgroundColor:
                    option.channel === 'whatsapp'
                      ? '#086d2d'
                      : option.channel === 'facebook'
                        ? '#4267B2'
                        : '#E1306C',
                  textShadow: '1px 1px 1px #000',
                  color: '#FFF',
                }}
                label={option.name}
                {...tagProps}
                size='small'
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant='outlined'
            placeholder={i18n.t('tickets.search.filterConections')}
            sx={theme.custom.selectField}
          />
        )}
        PaperComponent={({ children }) => (
          <Paper
            sx={{
              backgroundColor: theme.custom.colors.defaultBackground,
              '& .MuiAutocomplete-listbox': {
                color: theme.custom.colors.text,
              },
            }}
          >
            {children}
          </Paper>
        )}
      />
    </Box>
  );
}
